var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"navbar-list white--text",attrs:{"color":"#1A1D27","nav":"","dense":""}},_vm._l((_vm.routes),function(route,i){return (route.show)?_c('navbar-list-item',{key:i,staticClass:"level-0 mt-3",attrs:{"route":route,"level":1}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }